import React from 'react'
import {FaRegBookmark,FaBookmark} from 'react-icons/fa'
import { firestore, auth, signInWithGoogle } from '../../firebase/firebase-utils'

const Likes = ({ docid, collection }) => {

    const [validate, setValidate] = React.useState(false);
    const [saved, setSaved] = React.useState([]);
    const [User, setUser] = React.useState(null)

    auth.onAuthStateChanged(async user => {
        if (user) {
            await setUser(user)
        }
    })

    React.useEffect(() => {
        firestore.collection(collection).doc(docid).onSnapshot((feed) => {
            if (feed.exists) {
                var query = feed.data().saved;
                if(query){
                    setSaved(query)
                    if (User) {
                        var count = query.reduce((acc, ele) => {
                            return ele === User.uid ? acc + 1 : acc
                        }, 0)
                        if (count === 1) { setValidate(true) }else(setValidate(false))
                    }
                }
            }
        })
    }, [docid, collection, User])

    const savePost = () => {
        if (User && saved) {
            var array = saved;
            array.push(User.uid);
            firestore.collection(collection).doc(docid).update({
                saved: array
            })
        } else { window.alert("sign In required ...");signInWithGoogle() }
    }

    const unSavePost = () => {
        if(User && saved){
            var array = saved;
            array = saved.filter(uid => (uid !== User.uid))
            firestore.collection(collection).doc(docid).update({
                saved: array
            })
        }else{window.alert("sign In required ...");signInWithGoogle()}
    }

    return (
        <>
            {
                validate ?
                    <><FaBookmark style={{color:'#057BD0'}} onClick={unSavePost}/></>
                    :
                    <><FaRegBookmark onClick={savePost} /></>
            }
        </>
    )
}

export default Likes
